import axios from 'axios'
import {
  injectAccessTokenInterceptor,
  refreshTokenResponseInterceptor,
} from '~/services-v2/keycloack-api/keycloack-api.interceptors'

const baseURL = import.meta.env.VITE_SOLFACILPLUS_API_URL as string

const http = axios.create({ baseURL })

http.interceptors.request.use(injectAccessTokenInterceptor)
http.interceptors.response.use(c => c, refreshTokenResponseInterceptor)

export default http
